// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35ftg","newExpiryDate":"styles_newExpiryDate__LWWDC","footer":"styles_footer__3iZcd"};